import { Col, Pagination, Row, Typography } from 'antd';
import { PaginationProps } from 'antd/lib';
import { useTranslation } from 'react-i18next';
import CollapsableFilter from '../../../../shared/components/collapsable-filter/collapsable-filter';
import FormActions from '../../../../shared/components/form-actions/form-actions';
import PageTitle from '../../../../shared/components/page-title/page-title';
import { useBreakpoint } from '../../../../shared/hooks/use-breakpoint';
import useFormWithSearchParams from '../../../../shared/hooks/use-form-with-search-params';
import { CustomersFormFilterModel } from '../../../customers/models/customers-form-filter-model';
import { clientUsersFilterFormId } from '../../constants/constants';
import ClientUserFilterForm from './client-users-filter-form/client-users-filter-form';

interface Props {
  pagination?: PaginationProps;
}
const ClientUsersHeader = ({ pagination }: Props): JSX.Element => {
  const screens = useBreakpoint();
  const { t } = useTranslation('common');
  const form = useFormWithSearchParams<CustomersFormFilterModel>();

  return (
    <>
      {screens.sm ? (
        <>
          <PageTitle>{t('label.users')}</PageTitle>
          <ClientUserFilterForm form={form} />
          <Row justify="space-between">
            <Col className="paginationPadding" flex="auto">
              <FormActions form={form} formId={clientUsersFilterFormId} />
            </Col>
            <Col className="paginationPadding">
              <Pagination {...pagination} />
            </Col>
          </Row>
        </>
      ) : (
        <>
          <CollapsableFilter header={<Typography.Text strong>{t('label.filters')}</Typography.Text>} keyProp="1">
            <ClientUserFilterForm form={form} />
            <FormActions form={form} formId={clientUsersFilterFormId} />
          </CollapsableFilter>
          <div className="paginationPadding">
            <Pagination {...pagination} />
          </div>
        </>
      )}
    </>
  );
};
export default ClientUsersHeader;
